import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../../../webcommon/common/actionbutton/ActionButton';
import Checkbox from '../../../../webcommon/common/checkbox/Checkbox';
import defaultButtonStyle from '../../../../webcommon/common/actionbutton/ActionButton.module.scss';
import { noop } from 'lodash';
import defaultStyles from './ProcessTradesModal.module.scss';
import buttonStyle from './ActionButtonOverride.module.scss';

const ProcessTradesModal = (props) => {
    const clickButton = () => {
        if (props.process === 'Book') {
            props.submitModal();
        } else if (props.process === 'Cancel') {
            props.submitUnbooKTradesModal();
        } else if (props.process === 'Delete') {
            props.submitDeleteTradesModal();
        }
    };

    return (
        <div className={ props.styles.modalWrapper }>
            <div className={ props.styles.modalHeader }>
                Are you sure you want to {props.process } these {props.numberOfTrades} trade(s)?
            </div>
            <div className={ props.styles.modalTrades }>
                {props.trades.map(
                    trade => (
                        <div className={ props.styles.tradeRow } key={ trade.name }>
                            <div className={ props.styles.tradeName }>{trade.name} </div>
                            <div className={ props.styles.checkbox }><Checkbox
                                checked={ trade.confirmed }
                                onChange={ (checked) => {
                                    props.toggleTrade(checked, trade.name);
                                } }
                            />
                            </div>
                        </div>
                    )
                )}
            </div>
            <div className={ props.styles.modalButtons }>
                <div className={ props.styles.cancelButton }>
                    <ActionButton
                        accent
                        onClick={ props.cancelModal }
                    >
                        Close
                    </ActionButton>
                </div>

                <div className={ props.styles.submitButton }>
                    <ActionButton
                        accent
                        disabled={ !props.numberOfTrades }
                        onClick={ clickButton }
                        styles={ props.numberOfTrades ? buttonStyle : defaultButtonStyle }
                    >
                        {props.process}
                    </ActionButton>
                </div>
            </div>
        </div>
    );
};

ProcessTradesModal.propTypes = {
    cancelModal: PropTypes.func,
    numberOfTrades: PropTypes.number,
    process: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string),
    submitDeleteTradesModal: PropTypes.func,
    submitModal: PropTypes.func,
    submitUnbooKTradesModal: PropTypes.func,
    toggleTrade: PropTypes.func,
    trades: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
            booked: PropTypes.bool
        })
    )
};

ProcessTradesModal.defaultProps = {
    cancelModal: noop,
    numberOfTrades: 0,
    process: '',
    styles: defaultStyles,
    submitDeleteTradesModal: noop,
    submitUnbooKTradesModal: noop,
    submitModal: noop,
    toggleTrade: noop,
    trades: []
};

export default ProcessTradesModal;
